import { BridgeComponent } from '@hotwired/hotwire-native-bridge'
import { BridgeElement } from '@hotwired/hotwire-native-bridge'

/**
 * Bridge component for native dropdown menus.
 *
 * Menu container attributes:
 * - data-bridge-use-selected-icon: "true" to show selected item's icon on menu button
 * - data-bridge-ios-icon: SF Symbol name for custom iOS menu button icon
 * - data-bridge-android-icon: Material Symbol name for custom Android menu button icon
 * - data-bridge-color: Hex color code for menu button tint
 *
 * Menu item attributes (on data-bridge--menu-target="item"):
 * - data-bridge-title: Item title text
 * - data-bridge-ios-image: SF Symbol name for iOS item icon
 * - data-bridge-android-image: Material Symbol name for Android item icon
 * - data-bridge-selected: "true" if item is currently selected (shows checkmark)
 * - data-bridge-destructive: "true" for destructive actions (red text)
 */
export default class extends BridgeComponent {
    static component = 'menu'
    static targets = ['item']
    static values = {
        selected: Boolean,
    }

    connect() {
        super.connect()
        this.#addMenuButton()
    }

    disconnect() {
        super.disconnect()
        this.#removeMenuButton()
    }

    #addMenuButton() {
        const items = this.itemTargets.map((target) => {
            const element = new BridgeElement(target)

            return {
                title: element.title,
                iosImage: element.bridgeAttribute('ios-image'),
                androidImage: element.bridgeAttribute('android-image'),
                destructive: element.bridgeAttribute('destructive') == 'true',
                selected: element.bridgeAttribute('selected') == 'true',
            }
        })

        const color = this.bridgeElement.bridgeAttribute('color')
        const iosIcon = this.bridgeElement.bridgeAttribute('ios-icon')
        const androidIcon = this.bridgeElement.bridgeAttribute('android-icon')
        const useSelectedIcon = this.bridgeElement.bridgeAttribute('use-selected-icon') == 'true'
        this.send('connect', { items, color, iosIcon, androidIcon, useSelectedIcon }, (message) => {
            const item = this.itemTargets[message.data.index]
            new BridgeElement(item).click()
        })
    }

    #removeMenuButton() {
        this.send('disconnect')
    }
}
